import axios from 'axios';
import { URL_GET_CONTACT } from 'constants/urls';

const getContact = async (id) => {
	let { data } = await axios({
		method: 'GET',
		url: `${URL_GET_CONTACT}${id}`,
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
	});

	if (Object.keys(data).length === 0) {
		throw new Error('No Contact Detail Data!');
	} else {
		return data;
	}
};

export default getContact;
